import { useContext } from "react";
import { AuthContext } from "utils/providers";

export const useAuth = () => {
  return useContext(AuthContext);
};
